// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__NJj9X","count":"Pagination_count__1H4Rs","page":"Pagination_page__3lF8Y","itemsPerPage":"Pagination_itemsPerPage__3XQrj"};